/*
 * Copyright (c) Pro3W 2023.
 * author: Sławomir Moskal
 * filename: js_body_end.js
 * last update: 31.10.2023, 11:05
 */


//Dark mode
let mode = window.localStorage.getItem("mode"),
  root = document.getElementsByTagName("html")[0];
if (mode !== undefined && mode === "dark") {
  root.classList.add("dark-mode");
} else {
  root.classList.remove("dark-mode");
}

//function
(function () {
  "use strict";
  var t, e, r, a, n, o, l, c;
  null !== (e = document.querySelector('[data-bs-toggle="mode"]')) &&
  ((t = e.querySelector(".form-check-input")),
    "dark" === mode
      ? (root.classList.add("dark-mode"), (t.checked = !0))
      : (root.classList.remove("dark-mode"), (t.checked = !1)),
    e.addEventListener("click", function (e) {
      t.checked
        ? (root.classList.add("dark-mode"),
          window.localStorage.setItem("mode", "dark"))
        : (root.classList.remove("dark-mode"),
          window.localStorage.setItem("mode", "light"));
    }));
})();

//New cookie

// import "aos";
import AOS from '@dartmoon/aos-responsive'

AOS.init({
  // You AOS configs
})
window.AOS = AOS;
